export default, { PageDescriptionDesktop } from './page-description';



// WEBPACK FOOTER //
// ./app/components/page-description/index.js